type StandardApiResponse = {
  code?: number;
  status?: number;
  data: unknown;
};

const isStandardApiResponse = (
  payload: unknown,
): payload is StandardApiResponse =>
  Boolean(
    payload &&
      typeof payload === 'object' &&
      (typeof (payload as StandardApiResponse).code === 'number' ||
        typeof (payload as StandardApiResponse).status === 'number') &&
      Object.prototype.hasOwnProperty.call(payload, 'data'),
  );

/**
 * Answer's original APIs return a standard `{ status, data }` envelope, while
 * a few product-specific APIs return their JSON body directly. Preserve both
 * response contracts so a successful raw response is not mistaken for empty
 * data by the UI.
 */
// `any` is intentional here: Axios' interceptor API models success callbacks as
// returning AxiosResponse even though this project has always returned the
// unwrapped body from that callback.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unwrapApiResponse = (payload: unknown): any => {
  if (!isStandardApiResponse(payload)) {
    return payload;
  }

  if ((payload.code ?? payload.status) === 204) {
    return true;
  }
  return payload.data;
};
